import React from 'react';
import { Container, Navbar } from 'react-bootstrap';
import { BuyMeACoffeeIcon, EmailIcon, FacebookIcon } from '../aboutPage/FeedBackIcons';
import { APP_VERSION } from '../../version';

export function Footer() {
  return <Navbar bg='dark' variant='dark' fixed='bottom'>
    <Container fluid>
      <Navbar.Brand>
        © 2026 Steve Atkinson <EmailIcon /> <FacebookIcon /> <BuyMeACoffeeIcon />
        {' '}<small className='text-light opacity-75'>v.{APP_VERSION}</small>
      </Navbar.Brand>
    </Container>
  </Navbar>;
}
